export default function changeApiChoiceViewAction(context, payload, done) {
    context.dispatch('API_CHOICE_VIEW_CHANGED', payload);
    done();
}
